module.exports = __webpack_public_path__ + "static/media/hammer.fb50ae9f.svg";